<template>
  <div class="container">
    <div v-if="loading" class="text-center py-3"><i class="fas fa-spinner fa-spin fa-2x"></i></div>
    <div v-else class="row justify-content-center">
      <div class="col-md-8 mx-auto">
        <div class="row">
          <div class="col text-center">
            <h5 class="pb-1">{{heading}}</h5>
            <small v-if="campaign">{{campaign.name}}</small>
          </div>
        </div>

        <div class="row">

            <!-- Center -->
                <div class="col-md-8 text-center">
          <div v-if="uploading_1" class="py-2">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <div v-else class="py-2">
            <img
              v-if="advert_1"
              :src="advert_1"
              class="banner img-fluid mb-3"
              style="max-height:300px;" />

            <form
              v-if="!advert_1"
              @submit="upload_1"
              enctype="multipart/form-data">
              <label for="file-1-upload" class="btn btn-success btn-sm px-3">Upload 728 x 90</label>
              <input
                type="file"
                id="file-1-upload"
                hidden
                v-on:change="upload_1" />
            </form>

            <form v-else @submit="upload_1" enctype="multipart/form-data">
              <label for="file-1-upload" class="btn btn-success btn-sm px-3">Change 728 x 90</label>
              <input
                type="file"
                id="file-1-upload"
                hidden
                v-on:change="upload_1" />
            </form>
          </div>

                <div class="card">
          <div class="card-body px-md-4 pt-0">
            <div class="row mt-3">
              <div class="col">
                <label>Campaign Name</label>
                <input
                  type="text"
                  v-model="name"
                  class="form-control2" />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <label>Landing Page</label>
                <input
                  type="text"
                  v-model="url"
                  class="form-control2" />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col">
                <a href="/advertising" class="btn btn-dark col mt-2 mb-2">Cancel</a>
              </div>
              <div class="col">
                <button v-if="submitting" class="btn btn-danger col mt-2 mb-2">
                  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>
                </button>
                <button
                  v-else
                  type="submit"
                  class="btn btn-danger col mt-2 mb-2"
                  @click="saveCampaign">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

            </div>

            <!-- Right -->
            <div class="col-md-4 text-center">

                <div class="text-center">
          <div v-if="uploading_2" class="py-2">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <div v-else class="py-2">
            <img
              v-if="advert_2"
              :src="advert_2"
              class="banner img-fluid mb-3"
              style="max-height:300px;" />

            <form
              v-if="!advert_2"
              @submit="upload_2"
              enctype="multipart/form-data">
              <label for="file-2-upload" class="btn btn-success btn-sm px-3">Upload 300 x 600</label>
              <input
                type="file"
                id="file-2-upload"
                hidden
                v-on:change="upload_2" />
            </form>

            <form v-else @submit="upload_2" enctype="multipart/form-data">
              <label for="file-2-upload" class="btn btn-success btn-sm px-3">Change 300 x 600</label>
              <input
                type="file"
                id="file-2-upload"
                hidden
                v-on:change="upload_2" />
            </form>
          </div>
        </div>

            </div>

            
        </div>

        
      </div>
    </div>
  </div>
</template> 

<script>
import confetti from "canvas-confetti";

export default {
  props: ['edit','campaign_id'],
  data() {
    return {
      name: null,
      submitting: false,
      uploading_1: false,
      uploading_2: false,
      advert_1: null,
      advert_2: null,
      url: null,
      heading: null,
      adverts: [],
      campaign: {},
      loading: null,
    };
  },

    mounted() {
        if (this.edit) {
            this.heading = "Edit Campaign";
            this.getCampaign();
        } else {
            this.heading = "New Campaign";
        }
    },

  methods: {

    getCampaign() {

      this.loading = true;

      axios.post(`/campaigns/fetch`, {
        campaign_id: this.campaign_id,
      })
      .then((response) => {
        this.campaign = response.data.campaign;
        this.adverts = response.data.adverts;
      }).finally(() => {
        this.name = this.campaign.name;
        this.url = this.campaign.url;
        this.setAdverts(this.adverts);
      });

    },

    setAdverts(adverts) {
      if (adverts.length > 0) {
        for (let i = 0; i < adverts.length; i++) {
          if (adverts[i].orientation == 'Horizontal') {
            this.advert_1 = adverts[i].image;
          } else if (adverts[i].orientation == 'Vertical') {
            this.advert_2 = adverts[i].image;
          }
        }
      }
      this.loading = false;
    },

    async upload_1(e) {
      this.file = e.target.files[0];

      let existingObj = this;

      var document_response = this.document_check(this.file, 'image');

      if (document_response.success !== true)
        this.sweetfire(document_response.message);
      else {
        this.uploading_1 = true;

        const config = { headers: { "content-type": "multipart/form-data" } };

        let data = new FormData();
        data.append("file", this.file);
        data.append("orientation", "Horizontal");

        await axios
          .post(`/campaigns/upload-image`, data, config)
          .then(function (response) {
            if (response.data.success) {
              existingObj.advert_1 = response.data.url;
            } else {
              existingObj.sweetfire(response.data.message);
            }

            existingObj.uploading_1 = false;
          });
      }
    },

    async upload_2(e) {
      this.file = e.target.files[0];

      let existingObj = this;

      var document_response = this.document_check(this.file, 'image');

      if (document_response.success !== true)
        this.sweetfire(document_response.message);
      else {
        this.uploading_2 = true;

        const config = { headers: { "content-type": "multipart/form-data" } };

        let data = new FormData();
        data.append("file", this.file);
        data.append("orientation", "Vertical");

        await axios
          .post(`/campaigns/upload-image`, data, config)
          .then(function (response) {
            if (response.data.success) {
              existingObj.advert_2 = response.data.url;
            } else {
              existingObj.sweetfire(response.data.message);
            }

            existingObj.uploading_2 = false;
          });
      }
    },

    saveCampaign() {
        if (!this.name) {
        this.sweetfire("Please enter campaign name");
      } else if (!this.advert_1) {
        this.sweetfire("Please upload horizontal banner");
       } else if (!this.advert_2) {
        this.sweetfire("Please upload vertical banner");
      } else if (!this.url) {
        this.sweetfire("Please enter landing page url");
      } else {
        this.submitting = true;

        let existingObj = this;

        axios
          .post(`/campaigns/create`, {
            name: existingObj.name,
            advert_1: existingObj.advert_1,
            advert_2: existingObj.advert_2,
            url: existingObj.url,
            campaign_id: existingObj.campaign_id,
          })
          .then(function (response) {
            if (response.data.success) {
              existingObj.triggerConfetti();
              window.location.href = response.data.url
            } else {
              existingObj.submitting = false;
              existingObj.sweetfire(response.data.message);
            }
          });
      }
    },

    triggerConfetti() {
      const duration = 10 * 1000;

      confetti({
        particleCount: 100,
        spread: 160,
        origin: { y: 0.6 },
      });

      setTimeout(() => confetti.reset(), duration);
    },

  },
};
</script>